import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import { Layout, Container, ZigMenuItemSubHeader } from './styles.js';
import { MarginContainer } from '../../styled.js';
import { SubHeaderMenuButton, SubHeaderOption } from './atoms.js';
import ZigMenu from '../../display/ZigMenu/index.js';
import { useTheme, useMediaQuery } from '@mui/material';

function ZigSubHeader(_a) {
    var routes = _a.routes, sx = _a.sx, menuSx = _a.menuSx;
    var theme = useTheme();
    var sm = useMediaQuery(theme.breakpoints.down("sm"));
    var optionSx = {
        padding: "7px 28px",
        height: sm ? "unset" : "56px",
        whitespace: "normal",
    };
    return (React__default.createElement(Layout, null,
        React__default.createElement(MarginContainer, null,
            React__default.createElement(Container, { sx: sx }, routes.map(function (route, i) {
                var element = route.element, routes = route.routes;
                if (element) {
                    return React__default.createElement(React__default.Fragment, { key: route.id }, element);
                }
                else if (routes) {
                    return (React__default.createElement(ZigMenuItemSubHeader, { key: route.id, sx: __assign({ padding: 0, "> div": __assign(__assign({}, optionSx), { display: "flex", flex: 1, justifyContent: "center" }) }, route.sx), component: "span" },
                        React__default.createElement(ZigMenu, { placement: i > routes.length / 2 ? "bottom-end" : "bottom-start", matchAnchorWidth: true, component: function (_a) {
                                var open = _a.open;
                                return React__default.createElement(SubHeaderMenuButton, { route: route, open: open });
                            }, id: route.id, menuSx: __assign(__assign({ maxHeight: "300px" }, (route.dense && { ul: { padding: "15px 0" } })), menuSx), options: routes.map(function (r) { return (__assign(__assign({}, ((r.href || r.onClick) && {
                                element: (React__default.createElement(SubHeaderOption, { route: r, isSubOption: true, sx: __assign(__assign({}, optionSx), ((route.dense || r.separator) && {
                                        height: "auto",
                                    })) })),
                                preserveStyles: true,
                                sx: {
                                    color: "neutral300",
                                    padding: 0,
                                },
                            })), r)); }) })));
                }
                else {
                    return React__default.createElement(SubHeaderOption, { route: route, key: route.id, sx: optionSx, wrapMenuItem: true });
                }
            })))));
}

export { ZigSubHeader as default };
